import { css } from "styled-components";

export const createCssProperty = (property: string, value?: string) =>
    value
        ? css`
              ${property}: ${value};
          `
        : "";
